import React from 'react';
import { ContentWithImageAndCTA } from 'utils/types';
import InTheNewsSection from 'components/Enterprise/InTheNewsSection';

export interface InTheNewsContainerProps {
  content: {
    title: string;
    headline: string;
    listOfContentWithImages: ContentWithImageAndCTA[];
  };
}

export const InTheNewsContainer: React.FC<InTheNewsContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { title, headline, listOfContentWithImages } = content;

  const formattedListOfContent = listOfContentWithImages.map(item => {
    return {
      heading: item.heading,
      description: item.description.description,
      image: item.image?.fluid,
      imageAlt: item.image?.description,
      cta: item.cta,
    };
  });

  return (
    <InTheNewsSection
      title={title}
      headline={headline}
      listOfContentWithImages={formattedListOfContent}
    />
  );
};

export default InTheNewsContainer;
